import LoadingImg from '../../assets/images/loading.svg';
const Loading = () => {
  return (
    <>
      <div className="w-[100vw] h-[100vh] flex items-center justify-center bg-white dark:bg-dark-bg">
        <img src={LoadingImg} alt="" />
      </div>
    </>
  );
};
export default Loading;
